var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inestable)?_c('div',{staticClass:"d-flex align-items-center text-warning mr-3",attrs:{"title":_vm.titulo}},[_c('i',{staticClass:"fas fa-wifi fa-fw"}),_c('span',{staticClass:"small font-weight-bold ml-1 d-none d-md-inline"},[_vm._v("Conexión inestable")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }